import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  TableRow,
  TableCell,
  TableContainer,
  Table,
  TableBody,
  
} from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import { getOvertimeRequestByIdApi } from "app/redux/api/overtime";
import { useAuth } from "app/hooks/useAuth";
import { useDispatch } from "react-redux";
import { approveOrRejectOvertime } from "app/redux/actions/overtimeActions";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const ViewOvertimeRequest = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const dispatch = useDispatch();
  const [requestData, setRequestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleAction = (isApproved) => {
    setIsSubmitting(true);
    const statusData = { status: isApproved ? "Approved" : "Rejected" };

    dispatch(approveOrRejectOvertime(id, statusData))
      .then(() => {
        setRequestData((prevData) => ({
          ...prevData,
          status: statusData.status,
        }));
        // navigate(-1);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  useEffect(() => {
    if (id && token) {
      getOvertimeRequestByIdApi(id, token)
        .then((res) => {
          if (res.data.succeeded) {
            setRequestData(res.data.data);
          } else {
            toast.error("Failed to fetch request details.");
          }
        })
        .catch((err) => {
          toast.error("An error occurred while fetching the request.");
          navigate(-1);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, token, navigate]);

  if (loading) {
    return <CircularProgress />;
  }

  if (!requestData) {
    return <Typography>Request not found.</Typography>;
  }
  const getStatusChipColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Rejected":
        return "error";
      case "Pending":
      default:
        return "warning";
    }
  };
  function decimalToTime(hoursDecimal) {
    if (isNaN(hoursDecimal) || hoursDecimal < 0) return "00:00";
    const totalMinutes = Math.floor(hoursDecimal * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  }
  return (
    <SimpleCard>
      <Breadcrumb routeSegments={[{ name: "Overtime Request Details" }]} />
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Request Details
        </Typography>

        <TableContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", width: "30%" }}>
                  Employee Name
                </TableCell>
                <TableCell>{requestData.User?.name || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Employee Email
                </TableCell>
                <TableCell>{requestData.User?.email || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                <TableCell>
                  {dayjs(requestData.date).format("DD MMMM, YYYY")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Hours Requested
                </TableCell>
                <TableCell>{decimalToTime(requestData.hours)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color={getStatusChipColor(requestData.status)}
                    size="small"
                    sx={{ cursor: "default" }}
                  >
                    {requestData.status}
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", verticalAlign: "top" }}>
                  Reason
                </TableCell>
                <TableCell sx={{ whiteSpace: "pre-wrap" }}>
                  {requestData.reason}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Box>
      </Paper>
    </SimpleCard>
  );
};

export default ViewOvertimeRequest;
